import { LocalDataError } from '../types.js';
const DEVICE_CODE_RE = /^[A-Z][A-Z0-9]{1,3}$/;
export function assertValidDeviceCode(code) {
    if (!DEVICE_CODE_RE.test(code)) {
        throw new LocalDataError('INVALID_DEVICE_CODE', `Device code must be 2-4 chars, A-Z then A-Z0-9 (got "${code}")`);
    }
    return code;
}
//# sourceMappingURL=context.js.map